import script from "./setPartnershipSecond.vue?vue&type=script&setup=true&lang=js"
export * from "./setPartnershipSecond.vue?vue&type=script&setup=true&lang=js"

import "./setPartnershipSecond.vue?vue&type=style&index=0&id=36e7e08c&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36e7e08c"]])

export default __exports__